import { AgentDesktopRouter } from '@agent/agent-interface/agent-desktop-router';
import { AgentDesktopRouteParams } from '@agent/agent-interface/agent-desktop-routing.module';
import { Component, Directive, ElementRef, Injector, Input } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';

import { default as componentAjs } from './agent-booking-mail-qualification.component.ajs';

@Directive({
  selector: 'cng-agent-booking-mail-qualification-upgrade',
})
export class AgentBookingMailQualificationUpgradeComponent extends UpgradeComponent {
  @Input() responseId: string;

  constructor(elementRef: ElementRef, injector: Injector) {
    super(componentAjs, elementRef, injector);
  }
}

@Component({
  selector: 'cng-agent-booking-mail-qualification',
  template:
    '<cng-agent-booking-mail-qualification-upgrade [responseId]="responseId$ | async"></cng-agent-booking-mail-qualification-upgrade>',
})
export class AgentBookingMailQualificationComponent {
  readonly responseId$ = this.router.currentSnapshot$.pipe(AgentDesktopRouteParams.ResponseId.select);

  constructor(private readonly router: AgentDesktopRouter) {}
}
